import { CreditCardNetwork } from '@wix/cashier-common/dist/src/enums/payments/CreditCardNetwork';
import { PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';
import React from 'react';
import { DH } from '../../../../utils/DataHook';
import { t } from '../../../../utils/i18n';
import { CreditCardNetworkIcon } from '../CreditCardNetworkIcon';
import * as s from './styles.scss';

// Phase 2: get from metadata
const displayedCardNetworks: CreditCardNetwork[] = [
  CreditCardNetwork.MasterCard,
  CreditCardNetwork.Visa,
  CreditCardNetwork.Amex,
  CreditCardNetwork.Maestro,
];

export const SupportedCardNetworks: React.FunctionComponent<{
  providerId: PaymentProvider;
}> = (props) => (
  <div
    data-hook={DH.MethodsList.Item.SupportedCardNetworks}
    className={s.cardsContainer}
  >
    {displayedCardNetworks
      .filter(
        (cardNetwork) =>
          // temporary client-side fix (PAY-7543) until server will provide the solution
          !(
            props.providerId === PaymentProvider.LeumiCard &&
            cardNetwork === CreditCardNetwork.Amex
          )
      )
      .map((cardNetwork) => (
        <div className={s.cardIcon} key={cardNetwork}>
          <CreditCardNetworkIcon cardNetwork={cardNetwork} />
        </div>
      ))}
    <span className={s.moreLabel}>
      {t('paymentMethods.creditCard.moreNetworksLabel')}
    </span>
  </div>
);
SupportedCardNetworks.displayName = 'SupportedCardNetworks';
